import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IMenuLibraryItem, Organization, User } from 'src/app/models';
import { MealPlanService, OrganizationService, UserService } from 'src/app/services';

@Component({
  selector: 'app-menu-select',
  templateUrl: './menu-select.component.html',
  styleUrls: ['./menu-select.component.scss'],
})
export class MenuSelectComponent implements OnInit {
  public activeOrganization: Organization;
  public activeUser: User;
  public menus: IMenuLibraryItem[] = [];
  public searchTerm = '';

  constructor(
    private modalCtrl: ModalController,
    private mealPlanService: MealPlanService,
    private organizationService: OrganizationService,
    private userService: UserService,
  ) {
    this.activeUser = this.userService.getAppUser();
    this.activeOrganization = this.organizationService.getAppOrganization();
  }

  async ngOnInit() {
    if (!this.activeOrganization?.uid) {
      this.menus = [];
      return;
    }
    this.menus = (await this.mealPlanService.getMenusAsPromiseByOrganization(this.activeOrganization.uid)) || [];
  }

  getFilteredMenus() {
    return (this.menus || [])
      .filter((menu) => {
        if (!this.searchTerm) {
          return true;
        }
        return (menu.title || '').toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
      })
      .sort((a, b) => (a.title || '').localeCompare(b.title || ''));
  }

  selectMenu(menu: IMenuLibraryItem) {
    this.modalCtrl.dismiss({ status: 'selected', data: menu });
  }

  cancel() {
    this.modalCtrl.dismiss({ status: 'canceled' });
  }
}
